import { gridSize, gridSizeMdLg10, gridSizeMdLg12, gridSizeMdLg2, gridSizeMdLg6, useMapComponent } from "@/shared";
import { IconBtnModalMapComponent } from "@/shared/components/erp";
import { CustomTextField, CustomTextFieldNoForm } from "@/shared/components/ui";
import { GlobeEuropeAfricaIcon } from "@heroicons/react/24/solid";
import { Grid, InputAdornment, SvgIcon } from "@mui/material";
import { useEffect } from "react";

export type ClientesFormComponentActivacionesProps = {
  form: any;
  /** Traslado ya finalizado (GESTIONADA): el mapa se abre solo para VER
   *  (marcador fijo y sin escribir coordenadas al form). */
  soloLecturaMapa?: boolean;
};

const ClientesFormComponentActivaciones: React.FC<
  ClientesFormComponentActivacionesProps
> = ({ form, soloLecturaMapa = false }) => {
  const { errors } = form.formState;
  const shrink = true;
  const watchedCoords = form.watch("coordenadas");



  // const {
  //   Map,
  //   latLng,
  //   setLatLng,
  //   napsByCity,
  //   setCurrentCoordenadas,
  // } = useMapComponent({
  //   form,
  //   currentCity: form.getValues()?.coordenadas, // replaced by coordenadasCliente
  //   distanciaNapKey: "distancia",
  //   coordenadasCliente: form.getValues()?.coordenadas || watchedCoords || "",
  //   enabledFetchNaps: !!watchedCoords,
  //   // onChangeMarker,
  // });
  const {
    latLng,
    setLatLng,
    Map,
    napsByCity,
    setCurrentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: "",
    coordenadasCliente: form.getValues()?.coordenadas || "",
    enabledFetchNaps: true,
    canUpdateLatLong: !soloLecturaMapa,
  });

  useEffect(()=>{
    if(watchedCoords){
      setCurrentCoordenadas(watchedCoords);
    }
  },[watchedCoords])

  return (
    <>
      <CustomTextFieldNoForm
        label="Fecha de Instalación"
        value={form.getValues()?.fecha_instalacion || "Fecha no registrada"}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextFieldNoForm
        label="Hora de Instalación"
        value={form.getValues()?.hora_instalacion || "Hora no registrada"}
        size={gridSizeMdLg6}
        disabled
      />

      <CustomTextField
        name="identificacion"
        label="No. Identificación"
        control={form.control}
        defaultValue={form.getValues().identificacion || ""}
        error={errors.identificacion}
        helperText={errors.identificacion?.message?.toString() ?? ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextField
        name="linea"
        label="Número de Contrato"
        control={form.control}
        defaultValue={form.getValues().prospecto_data?.linea || ""}
        error={errors.linea}
        helperText={errors.linea?.message?.toString() ?? ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      <CustomTextField
        name="razon_social"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().razon_social || ""}
        error={errors.razon_social}
        helperText={errors.razon_social?.message?.toString() ?? ""}
        shrink={shrink}
        disabled
      />
      <CustomTextFieldNoForm
        label="Plan"
        value={form.getValues()?.plan_data?.nombre || "Plan no registrado"}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextFieldNoForm
        label="Etiqueta"
        value={form.getValues()?.contrato_data?.tag || "Etiqueta no registrada"}
        size={gridSizeMdLg6}
        disabled
      />


        <Grid {...gridSizeMdLg12} item container alignItems="center">
          <Grid item {...gridSizeMdLg10}>
            <CustomTextField
              type="coordenada"
              control={form.control}
              name="coordenadas"
              defaultValue={form.getValues().coordenadas || ""}
              size={gridSize}
              label="Coordenadas del Cliente"
              error={errors.coordenadas}
              startAdornment={
                <InputAdornment position="start">
                  <SvgIcon fontSize="small">
                    <GlobeEuropeAfricaIcon />
                  </SvgIcon>
                </InputAdornment>
              }
              disabled={true}
              helperText={errors.coordenadas?.message}
              onChangeValue={(value) => {
                console.log("value", value);
              }}
            />
          </Grid>
          <Grid item container {...gridSizeMdLg2} justifyContent="center" justifyItems={"center"}>
            <IconBtnModalMapComponent
              coords={form?.getValues()?.coordenadas || ""}
              btnColor="info"
              showCustomMap
              customMap={
                <Map
                  coordenadas={
                    {
                      lat: +form?.getValues()?.coordenadas?.split(",")?.[0],
                      lng: +form?.getValues()?.coordenadas?.split(",")?.[1]
                    }
                  }
                  napsByCity={napsByCity || []}
                  setLatLng={setLatLng}
                  canDragMarker={!soloLecturaMapa}
                  canRuler={false}
                />
              }
            />
          </Grid>
        </Grid>


    </>
  );
};

export default ClientesFormComponentActivaciones;
